import { useEffect } from 'react';

import { useGetSupportDataQuery } from 'generated/sanity-graphql';
import { useErrorContext } from 'state/errors';

export const useSupportData = () => {
  const FEATURE_SUPPORT_DATA_SINGLETON_ID = 'support-data-singleton';

  const { data, loading } = useGetSupportDataQuery({
    variables: { supportDataId: FEATURE_SUPPORT_DATA_SINGLETON_ID },
  });

  const { setSanityDataRef } = useErrorContext();
  useEffect(() => {
    if (!loading && data) {
      setSanityDataRef({ data });
    }
  }, [loading, data, setSanityDataRef]);

  const {
    deliveryMissingItemsSubcategory,
    deliveryNeverArriveSubcategory,
    orderingIssuesCategoryGroup,
    supportCategoryGroups,
    supportDataFaqs,
  } = data?.SupportData ?? {};

  return {
    deliveryMissingItemsSubcategory,
    deliveryNeverArriveSubcategory,
    isSupportDataLoading: loading,
    orderingIssuesCategoryGroup,
    supportCategoryGroups,
    supportDataFaqs,
  };
};
